import { useSelector } from 'react-redux';
import { Navigate } from 'react-router';
import { getDefaultLandingPath } from 'utils-ts/login';

const LandingRedirect = () => {
  const userData = useSelector((state) => state.user.data);
  const appConfig = useSelector((state) => state.appConfig?.data);

  return <Navigate to={getDefaultLandingPath(userData?.type, userData?.AccessRoles, appConfig)} replace />;
};

export default LandingRedirect;
